<template>
  <svg
    fill="none"
    height="30"
    role="img"
    viewBox="0 0 20 30"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Filled down arrow</title>
    <path d="M10 22L1.33974 7H18.6603L10 22Z" fill="black" />
  </svg>
</template>
